<template>
  <div class="main-content mt20">
    <!-- 自定义文件夹和数据标签池区域 -->
    <m-folder-tags-section v-bind="$attrs" ref="folderTagsSectionRef" />
  </div>
</template>

<script setup>
import { ref } from 'vue'

import MFolderTagsSection from './MFolderTagsSection.vue'

const folderTagsSectionRef = ref(null)
/** @description 获取文件夹树 */
function getData() {
  return folderTagsSectionRef.value.getFolderTree()
}

defineExpose({
  getData,
})
</script>

<style scoped>
.main-content {
  height: 100%;
  width: 100%;
  overflow: hidden;
  background: #f8f9fa;
  display: flex;
  flex-direction: column;
}
</style>
